/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1AccountNumberState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_ACCOUNT_NUMBER_STATE_ENTITY_NAME = 'ixc.payments.v1.AccountNumber';
export const ixcPaymentsV1AccountNumberStateEntity = new schema.Entity<IxcPaymentsV1AccountNumberState>(IXC_PAYMENTS_V1_ACCOUNT_NUMBER_STATE_ENTITY_NAME, {}, { idAttribute: 'accountNumberId' });

